import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import * as css from './PrintButton.css';
import Print from '../../../../assets/icons/Print';
import {RootState} from '../../../../redux/store.type';

function PrintButton() {
    const {t} = useTranslation('eTicket');
    const hasPrintable = useSelector((s: RootState) => (s.eTicket.data?.tickets ?? []).some(ticket => !ticket.canceled));

    if(!hasPrintable) return null;

    return (
        <css.printButton type="button" onClick={() => window.print()} data-cy="eticket-print-button">
            <Print />
            {t('printTickets')}
        </css.printButton>
    );
}

export default PrintButton;
